import React, { useState, useEffect } from 'react';
import { Alert, Button } from 'reactstrap';

const Toast = ({ 
  isOpen, 
  onClose, 
  type = 'success', 
  title, 
  message, 
  duration = 5000,
  showCloseButton = true 
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      
      if (duration > 0) {
        const timer = setTimeout(() => {
          handleClose();
        }, duration);
        
        return () => clearTimeout(timer);
      }
    }
  }, [isOpen, duration]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300); // Allow time for fade out animation
  };

  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return 'ni ni-check-bold';
      case 'error':
        return 'ni ni-notification-70';
      case 'warning':
        return 'ni ni-alert-circle';
      case 'info':
        return 'ni ni-info';
      default:
        return 'ni ni-check-bold';
    }
  };

  return (
    <div 
      className={`toast-notification ${isVisible ? 'show' : 'hide'}`}
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 9999,
        minWidth: '300px',
        maxWidth: '400px',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(100%) scale(0.95)',
        opacity: isVisible ? 1 : 0,
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)'
      }}
    >
      <Alert 
        color={type} 
        className="mb-0"
        style={{
          border: 'none',
          borderRadius: '8px',
          boxShadow: 'none'
        }}
      >
        <div className="d-flex align-items-start">
          <div className="flex-shrink-0 mr-3">
            <i className={`${getIcon()} text-${type === 'success' ? 'white' : type === 'error' ? 'white' : type === 'warning' ? 'white' : 'white'}`} 
               style={{ fontSize: '1.2rem' }}></i>
          </div>
          <div className="flex-grow-1">
            {title && (
              <div className="font-weight-bold text-white mb-1">
                {title}
              </div>
            )}
            <div className="text-white" style={{ fontSize: '0.9rem' }}>
              {message}
            </div>
          </div>
          {showCloseButton && (
            <div className="flex-shrink-0 ml-2">
              <Button
                color="link"
                size="sm"
                onClick={handleClose}
                className="p-0 text-white"
                style={{ 
                  border: 'none',
                  background: 'none',
                  fontSize: '1.2rem',
                  lineHeight: 1
                }}
              >
                <i className="ni ni-fat-remove"></i>
              </Button>
            </div>
          )}
        </div>
      </Alert>
    </div>
  );
};

export default Toast;
